import React from "react"
import { Image, Flex, Box, Text } from "rebass"

import Reveal from "../reveals"
import RowWrapper from "./RowWrapper"
import MediasGallery from "./MediasGallery"
import ButtonsNav from "./ButtonsNav"

const RowTextComponent = ({ data }) => {
  const {
    image,
    video,
    title,
    titleHeadingTag,
    text,
    textOrder,
    buttonsButtons,
    alignItems,
    justifyContent,
    revealAnimation,
    mediasMediasGrid,
    mediasMediasGridGap,
    mediasMediasGridColumns,
    mediasMediasGallery,
  } = data

  const hasMedias =
    image !== null || video !== null || mediasMediasGallery !== null

  return (
    <RowWrapper {...data}>
      <Flex
        flexDirection={["column", null, null, "row"]}
        justifyContent={justifyContent}
        alignItems={alignItems}
      >
        <Box
          as="aside"
          width={hasMedias ? [1, null, null, "50%"] : [1]}
          flexDirection="column"
          order={[2, null, null, textOrder]}
          pl={
            textOrder === "2" && hasMedias
              ? ["15px", null, 0, 5, 6]
              : ["15px", 0]
          }
          pr={
            textOrder === "1" && hasMedias
              ? ["15px", null, 0, 5, 5]
              : ["15px", 0]
          }
          pt={[hasMedias ? 4 : 0, null, null, 0]}
        >
          <Box maxWidth={hasMedias ? "500px" : ["inherit", null, null, null, "80%"]} mx="auto">
            {title && (
              <Reveal delay={0.15} animation={revealAnimation}>
                <Text as={titleHeadingTag} mb="1em">
                  {title}
                </Text>
              </Reveal>
            )}
            {text && (
              <Reveal delay={0.25} animation={revealAnimation}>
                <Box
                  mx={justifyContent === "center" ? "auto" : 0}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </Reveal>
            )}
            {buttonsButtons && (
              <Reveal delay={0.35} animation={revealAnimation}>
                <ButtonsNav data={buttonsButtons} pt={[3]} />
              </Reveal>
            )}
          </Box>
        </Box>

        {hasMedias && (
          <Box
            as="aside"
            width={[1, 1, 1, "50%"]}
            order={[1, null, null, textOrder === "1" ? 2 : 1]}
          >
            <Reveal
              delay={0.25}
              animation={textOrder === "1" ? "from-right" : "from-left"}
            >
              {(image) && <Image srcSet={image.srcSet} alt={image.title} width={[`100%`]} />}

              {/* video */}
              {video && (
                <Box as="video" width={"100%"} muted autoPlay loop playsInline>
                  <source src={video.mediaItemUrl} />
                </Box>
              )}
            </Reveal>

            {mediasMediasGallery && (
              <MediasGallery
                grid={mediasMediasGrid}
                gap={mediasMediasGridGap}
                columns={mediasMediasGridColumns}
                medias={mediasMediasGallery}
                revealAnimation={revealAnimation}
              />
            )}
          </Box>
        )}
      </Flex>
    </RowWrapper>
  )
}

export default RowTextComponent
